type GenericObject = {
  [key: string]: any
}
type SetObject = {
  path: string
  value: any
  target: GenericObject
}
class Keypath {
  static get(keypath: string, target: GenericObject) {
    return keypath.split(".").reduce((previous, current) => {
      if (previous) return previous[current]
      else return null
    }, target)
  }
  static drop(path: string | string[], target: GenericObject) {
    if (!target || !path) return

    if (typeof path === "string") path = path.split(".")

    for (var i = 0; i < path.length - 1; i++) {
      target = target[path[i]]
      if (typeof target === "undefined") return
    }

    let key = path.pop()
    if (!key) return
    if (Array.isArray(target)) {
      target.splice(parseInt(key), 1)
    } else {
      delete target[key]
    }
  }
  static set({ path, value, target }: SetObject) {
    var schema = target
    var pList = path.split(".")
    var len = pList.length
    for (var i = 0; i < len - 1; i++) {
      var elem = pList[i]
      if (!schema[elem]) schema[elem] = {}
      schema = schema[elem]
    }

    schema[pList[len - 1]] = value
  }
}

export default Keypath
